export interface ISearchBarResources {
  searchWatermark: string;
  noResults: string;
  searchHistory: string;
  searchTitle:string;
  searchPopularTitle:string;

}

export const SearchBarResources: ISearchBarResources = {
  searchWatermark: "Szukaj w goodie",
  noResults: "Brak wyników dla tego wyszukiwania",
  searchHistory: "Ostatnio wyszukiwane",
  searchTitle: "Podpowiedzi",
  searchPopularTitle: "Najpopularniejsze frazy",
};
